import React, {useState, useEffect} from 'react';
import Button from '@mui/material/Button';
import { useParams } from "react-router-dom";
import '../../Styles/Components/Persons/Preview_Person.css';
import Dialog_alert from '../PublicForms/Dialog_alert.js';
import Header from '../PublicForms/Header.js';
import Navigation_Bar from '../PublicForms/Navigation_Bar.js';
import { ScrollToTop } from '../PublicForms/ScrollToTop.js';

export default function Preview_One_Post(props) {

    const{personID,subscriptID} = useParams();
    const[openNav, setOpenNav] = useState(false);  
    const[cost, setCost] = useState();
    const[number, setNumber] = useState();
    const[reportTitle, setReportTitle] = useState("");
    const[printData, setPrintData] = useState([]);
    const[message, setMessage] = useState([]);
    const[messTitle, setMessTitle] = useState("");
    const[showDialog, setShowDialog] = useState(false);
    const[width, setWidth] = useState(0);
   
    useEffect(() => {
      function handleResize() {
        setWidth(window.innerWidth)
      }
      
      window.addEventListener("resize", handleResize)
      
      handleResize()
      
      
    }, []);

 
   

    const closeOpenDialog = (open) =>
    {
    
      var arr = message;
      arr.splice(0, message.length);
      setMessage(arr);
       setShowDialog(false);
    }  
  

    const handleDB = () =>
    {
      setPrintData([]);    
        if((reportTitle === undefined || reportTitle === "" || reportTitle === null ) || (cost === undefined || cost === null || cost === "" || parseFloat(cost) < 0 || (number === undefined || number === null || number === "" || parseInt(number) < 0)))
        {
            setMessTitle("توجه");
            setMessage((prevMessages) => {
                return [
                ...prevMessages, // shallow copy into new array reference
                "لطفا مقادیر را به درستی وارد کنید",      // append new element
                ];
            });
            setShowDialog(true);

        }else
        {
          setPrintData((prev) => {
            return [
            ...prev, // shallow copy into new array reference
            reportTitle,      // append new element
            ];
          });
          
          setPrintData((prev) => {
            return [
            ...prev, // shallow copy into new array reference
            cost,      // append new element
            ];
        });
          window.open(`/onePost/${subscriptID}/${reportTitle}/${cost}/${number}`,'_blank', 'rel=noopener noreferrer');

          
        }     
       
    }
 

      const handleNave = ()=>
      {
          setOpenNav(!openNav);
  
      }

      const handleNaveForm = ()=>
      {
        if(!openNav)
          {
            setOpenNav(!openNav)
          }
      }
 
    if(width > 999)
    {
      return (
        <div className='prevPerson'>
         
           <Header />
            <div className="navClass">
                    <Navigation_Bar />
                
            </div>
                
            <div className='prevPersonContainer'>

              <div className='row'>

                <div className='col-md-1'></div>
                   <div className='col-md-11'>
                    
                    <div className='prevPersonForm'>
                      <div className='row'>
                          <div className="col-md-6 form-group">
                                  <label htmlFor="duration"> شماره مجله:</label>
                                  <input type="number" className="form-control" id="name" value={reportTitle}  onChange={(e)=>setReportTitle(e.target.value)} 
                                      onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                          </div>
                          <div className="col-md-6 form-group">
                              <label htmlFor="cost"> قیمت هر جلد:</label>
                              <input type="number" className="form-control" id="cost" value={cost}  onChange={(e)=>setCost(e.target.value)} 
                                  onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                          </div>
                          <div className="col-2 form-group">
                              <label htmlFor="number"> تعداد جلد:</label>
                              <input type="number" className="form-control" id="number" value={number}  onChange={(e)=>setNumber(e.target.value)} 
                                  onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                          </div>
                      </div>
                    </div>
                    {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
                           
                  </div>
                
                 </div>

                  <div className='row'>
                      
                      <div className='col-md-4'></div>
                      
                      <Button className='col-md-3' onClick={handleDB} autoFocus>
                        چاپ
                      </Button>
                      
                      <div className='col-md-2'></div>

                  </div>
           
        </div>

      </div>
      );
    }else
    {
      return (
        <div className='prevPerson-all-responsive'>
                  <ScrollToTop />

            <div className= {openNav? "navClass" : "navClass navClassOpen"}>
                                

                <Navigation_Bar />
                
            </div>

              <div className='prevPerson'>
                      
                      <Header handleNave={handleNave}/>
                      
                        <div className='prevPersonContainer' onClick={()=>handleNaveForm()}>

                          <div className='row'>

                              <div className='col-md-12'>
                                
                                <div className='prevPersonForm'>
                                  <div className='row'>
                                      <div className="col-sm-6 form-group">
                                              <label htmlFor="duration"> شماره مجله:</label>
                                              <input type="number" className="form-control" id="name" value={reportTitle}  onChange={(e)=>setReportTitle(e.target.value)} 
                                                  onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                                      </div>
                                      <div className="col-sm-6 form-group">
                                          <label htmlFor="cost"> قیمت هر جلد:</label>
                                          <input type="number" className="form-control" id="cost" value={cost}  onChange={(e)=>setCost(e.target.value)} 
                                              onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                                      </div>
                                      <div className="col-4 form-group">
                                          <label htmlFor="number"> تعداد جلد:</label>
                                          <input type="number" className="form-control" id="number" value={number}  onChange={(e)=>setNumber(e.target.value)} 
                                              onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                                      </div>
                                  </div>
                                </div>

                                {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
                                       
                              </div>
                            
                          </div>

                        
                          <div className='row'>
                                
                                <div className='col-1 col-sm-3 col-md-4'></div>
                                
                                <Button className='col-10 col-sm-6 col-md-4' onClick={handleDB} autoFocus>
                                  چاپ
                                </Button>
                              
                                <div className='col-1 col-sm-3 col-md-4'></div>

                            </div>
                      
                    </div>

              </div>

        </div>
       
      );
    }
      
    
   
  }
